import Cookies from 'js-cookie'

const TOKEN_KEY = 'rag_access_token'
const REFRESH_TOKEN_KEY = 'rag_refresh_token'
const USER_INFO_KEY = 'rag_user_info'

// Token相关操作
export function getToken() {
    return Cookies.get(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY) || undefined
}

export function setToken(token) {
    console.log('setToken', token)
    Cookies.set(TOKEN_KEY, token, { expires: 7 }) // 7天过期
    localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
    Cookies.remove(TOKEN_KEY)
    localStorage.removeItem(TOKEN_KEY)
}

// Refresh Token相关操作
export function getRefreshToken() {
    return Cookies.get(REFRESH_TOKEN_KEY) || localStorage.getItem(REFRESH_TOKEN_KEY) || undefined
}

export function setRefreshToken(token) {
    Cookies.set(REFRESH_TOKEN_KEY, token, { expires: 30 }) // 30天过期
    localStorage.setItem(REFRESH_TOKEN_KEY, token)
}

export function removeRefreshToken() {
    Cookies.remove(REFRESH_TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
}

// 用户信息相关操作
export function getUserInfo() {
    const userInfo = localStorage.getItem(USER_INFO_KEY)
    return userInfo ? JSON.parse(userInfo) : null
}

export function setUserInfo(userInfo) {
    localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
}

export function removeUserInfo() {
    localStorage.removeItem(USER_INFO_KEY)
}

// 清除所有认证信息
export function clearAuth() {
    removeToken()
    removeRefreshToken()
    removeUserInfo()
}

// 检查token是否过期
export function isTokenExpired(token) {
    if (!token) {
        token = getToken()
    }
    if (!token) {
        return true
    }
    try {
        // 解析JWT token
        const payload = JSON.parse(atob(token.split('.')[1]))
        const currentTime = Math.floor(Date.now() / 1000)
        return payload.exp < currentTime
    } catch (error) {
        console.error('Token解析失败:', error)
        return true
    }
}

// 获取token剩余有效时间（秒）
export function getTokenRemainingTime(token) {
    if (!token) {
        token = getToken()
    }
    if (!token) {
        return 0
    }
    try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        const currentTime = Math.floor(Date.now() / 1000)
        return Math.max(0, payload.exp - currentTime)
    } catch (error) {
        console.error('Token解析失败:', error)
        return 0
    }
}

// 检查是否需要刷新token（剩余时间少于5分钟）
export function shouldRefreshToken(token) {
    const remainingTime = getTokenRemainingTime(token)
    return remainingTime > 0 && remainingTime < 300 // 5分钟
}

// 从token中获取用户信息
export function getUserFromToken(token) {
    if (!token) {
        token = getToken()
    }
    if (!token) {
        return null
    }
    try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        return {
            id: payload.sub,
            username: payload.username,
            email: payload.email,
            roles: payload.roles || [],
            permissions: payload.permissions || []
        }
    } catch (error) {
        console.error('Token解析失败:', error)
        return null
    }
}

// 权限检查函数
export function hasPermission(permission, userPermissions) {
    if (!userPermissions) {
        const userInfo = getUserInfo()
        userPermissions = userInfo?.permissions || []
    }
    return userPermissions?.includes(permission) || userPermissions?.includes('*') || false
}

export function hasRole(role, userRoles) {
    if (!userRoles) {
        const userInfo = getUserInfo()
        userRoles = userInfo?.roles || []
    }
    return userRoles?.includes(role) || userRoles?.includes('ADMIN') || false
}

export function hasAnyRole(roles, userRoles) {
    return roles.some(role => hasRole(role, userRoles))
}

export function hasAnyPermission(permissions, userPermissions) {
    return permissions.some(permission => hasPermission(permission, userPermissions))
}